import Layout from "layouts";
import React from "react";
import { useParams } from "react-router-dom";
import SubscriptionDetailsComponent from "./SubscriptionDetailsComponent";

export default function SubscriptionDetails() {
  const { orderId = "" } = useParams();
  return (
    <Layout
      breadCrumb={[
        { label: "Subscriptions", to: "/subscriptions" },
        { label: `Subscription#${orderId}`, to: "#" },
      ]}
    >
      <SubscriptionDetailsComponent orderId={orderId} />
    </Layout>
  );
}
